/* Registrazione del service worker per la PWA di Vexel POS.
 * Registra /service-worker.js (servito dalla cartella public).
 * In sviluppo su localhost la registrazione viene saltata per non
 * interferire con l'hot reload. */

function isLocalhost() {
  return Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname),
  );
}

export function register() {
  if (!('serviceWorker' in navigator)) return;
  if (isLocalhost()) return; // evita cache aggressiva in sviluppo locale

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // Nuova versione disponibile: attiva subito e ricarica una volta.
              try { registration.waiting && registration.waiting.postMessage({ type: 'SKIP_WAITING' }); } catch (e) {}
            }
          };
        };
      })
      .catch(() => { /* registrazione fallita: l'app funziona comunque online */ });

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
